import {createContext} from 'react';
import {decorate, observable} from 'mobx';

class DialogStore {
  config = null;
  showChangePassword = false;
  showAccountSetting = false;
  showSetupTOTPAuth = false;
}

decorate(DialogStore, {
  config: observable,
  showChangePassword: observable,
  showAccountSetting: observable,
  showSetupTOTPAuth: observable
});

export const dialogStore = new DialogStore();

export const dialogStoreContext = createContext(dialogStore);
